'use strict';

var smsModule = angular.module('t2g.sms', [
  'ui.router',
  require('t2g.common.data-access.billing').name,
  require('t2g.common.data-access.payment').name,
  require('t2g.common.services.modelService').name,
]);

module.exports = smsModule;

smsModule.controller('SMSCreditCtrl', require('./SMSCreditCtrl'));

smsModule.config(function($stateProvider) {
  $stateProvider
    .state('private.main.sms', {
      url: '/sms',
      title: 'SMS',
      templateUrl: '/app/modules/sms/SMSView.html?v=4.5.6',
    })
    .state('private.main.sms.credit', {
      url: '/credit',
      title: 'SMS',
      templateUrl: '/app/modules/sms/SMSCreditView.html?v=4.5.6',
      controller: 'SMSCreditCtrl',
      resolve: {
        officeResolve: function(OfficeDA) {
          return OfficeDA.get();
        },
        smsCreditResolve: function(Billing) {
          return Billing.getSMSCredit();
        },
      },
    });
});



// WEBPACK FOOTER //
// ./src/app/modules/sms/SMSModule.js